import React, { useState, useEffect } from "react";
import "../../components/AddPetCrate/AddPetCrate.css";
import axios from "axios";

const AddPetCrateQuantity = ({
  tokenStorage,
  openAddProfile,
  setOpenAddProfile,
  successMessage,
  setSuccessMessage,
  userDetailResponse,
  RegionDetailResponse,
}) => {
  const baseAPI = process.env.REACT_APP_API_URL;

  const [crateTypes, setCrateTypes] = useState([]);
  const [formData, setFormData] = useState({
    RegionID: "",
    Crate_Type_Id: "",
    InventoryName: "Crate",
    total_Inventory: "",
    Created_By: "",
    Is_Active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "total_Inventory") {
      if (value === "" || /^[0-9\b]+$/.test(value)) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    const activeCrates = userDetailResponse.filter(
      (detail) => detail.Is_Active === true
    );

    const crateTypesData = activeCrates.map((detail) => ({
      id: detail.ID,
      Crate_Type: detail.Crate_Type,
    }));

    setCrateTypes(crateTypesData);
  }, [userDetailResponse]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      formData.InventoryName === "" ||
      formData.total_Inventory === "" ||
      formData.RegionID === "" ||
      formData.Crate_Type_Id === "" ||
      formData.Is_Active === ""
    ) {
      alert("Please fill in all fields before submitting.");
      return;
    }

    if (isNaN(formData.total_Inventory)) {
      alert("Quantity should be a numeric value.");
      return;
    }

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}adminpost/AddRegionInventory?Id=0`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      setFormData({
        RegionID: "",
        Crate_Type_Id: "",
        InventoryName: "Crate",
        total_Inventory: "",
        Created_By: "",
        Is_Active: "true",
      });

      setOpenAddProfile(!openAddProfile);
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      <br />
      <div className="petCrateDetail">
        <form className="petCrate-form" onSubmit={handleSubmit}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Product Name</td>
                <td>Region</td>
                <td>Quantity</td>
                <td>Status</td>
              </tr>
              <tr>
                <td>
                  <select
                    name="Crate_Type_Id"
                    value={formData.Crate_Type_Id}
                    onChange={handleChange}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                    }}
                  >
                    <option value="">Select a crate type</option>
                    {crateTypes.map((crate) => (
                      <option key={crate.id} value={crate.id}>
                        {crate.Crate_Type}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    name="RegionID"
                    value={formData.RegionID}
                    onChange={handleChange}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                    }}
                  >
                    <option value="">Select Region</option>
                    {RegionDetailResponse.map((reg) => (
                      <option key={reg.region_id} value={reg.region_id}>
                        {reg.region_name}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    name="total_Inventory"
                    value={formData.total_Inventory}
                    placeholder="Enter Quantity*"
                    onChange={handleChange}
                    required
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                    }}
                  />
                </td>
                <td>
                  <select
                    name="Is_Active"
                    value={formData.Is_Active}
                    onChange={handleChange}
                    required
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                    }}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
        
          <div className="reset-addPetCrateQuantity-button">
            <button
              type="button"
              style={{ backgroundColor: "#F15843", color: "white" }}
              onClick={() =>
                setFormData({
                  RegionID: "",
                  Crate_Type_Id: "",
                  InventoryName: "Crate",
                  total_Inventory: "",
                  Created_By: "",
                  Is_Active: "true",
                })
              }
            >
              Reset
            </button>
            <button
              type="submit"
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Save
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default AddPetCrateQuantity;
